// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.loading-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 300px;
  width: 100%;
  padding: 40px;
}

.justice-loader {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: 1rem;
}
.justice-loader .gavel {
  font-size: 48px;
  margin-bottom: 16px;
  animation: swing 1.5s ease-in-out infinite;
  transform-origin: center top;
}
.justice-loader .gavel .gavel-img {
  width: 60px;
  height: 60px;
}
.justice-loader .loading-text {
  font-size: 16px;
  color: #666;
  font-weight: 500;
  opacity: 0.8;
  animation: pulse 2s ease-in-out infinite;
}

@keyframes swing {
  0%, 100% {
    transform: rotate(0deg);
  }
  20% {
    transform: rotate(15deg);
  }
  40% {
    transform: rotate(-10deg);
  }
  60% {
    transform: rotate(5deg);
  }
  80% {
    transform: rotate(-2deg);
  }
}
@keyframes pulse {
  0%, 100% {
    opacity: 0.6;
  }
  50% {
    opacity: 1;
  }
}
.hammer-loader {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.hammer-loader .hammer {
  font-size: 40px;
  margin-bottom: 16px;
  animation: hammer 1s ease-in-out infinite;
  transform-origin: bottom center;
}
.hammer-loader .anvil {
  font-size: 24px;
  margin-bottom: 16px;
  animation: anvil-shake 1s ease-in-out infinite;
}

@keyframes hammer {
  0%, 100% {
    transform: rotate(0deg);
  }
  25% {
    transform: rotate(-45deg);
  }
  50% {
    transform: rotate(-90deg);
  }
  75% {
    transform: rotate(-45deg);
  }
}
@keyframes anvil-shake {
  0%, 100% {
    transform: translateX(0);
  }
  25%, 75% {
    transform: translateX(-2px);
  }
  50% {
    transform: translateX(2px);
  }
}`, "",{"version":3,"sources":["webpack://./src/components/JusticeLoader/JusticeLoader.scss"],"names":[],"mappings":"AACA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,iBAAA;EACA,WAAA;EACA,aAAA;AAAF;;AAGA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,kBAAA;EACA,SAAA;AAAF;AAEE;EACE,eAAA;EACA,mBAAA;EACA,0CAAA;EACA,4BAAA;AAAJ;AAEI;EACE,WAAA;EACA,YAAA;AAAN;AAIE;EACE,eAAA;EACA,WAAA;EACA,gBAAA;EACA,YAAA;EACA,wCAAA;AAFJ;;AAOA;EAEE;IAEE,uBAAA;EANF;EASA;IACE,wBAAA;EAPF;EAUA;IACE,yBAAA;EARF;EAWA;IACE,uBAAA;EATF;EAYA;IACE,wBAAA;EAVF;AACF;AAaA;EAEE;IAEE,YAAA;EAbF;EAgBA;IACE,UAAA;EAdF;AACF;AAkBA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;AAhBF;AAkBE;EACE,eAAA;EACA,mBAAA;EACA,yCAAA;EACA,+BAAA;AAhBJ;AAmBE;EACE,eAAA;EACA,mBAAA;EACA,8CAAA;AAjBJ;;AAqBA;EAEE;IAEE,uBAAA;EApBF;EAuBA;IACE,yBAAA;EArBF;EAwBA;IACE,yBAAA;EAtBF;EAyBA;IACE,yBAAA;EAvBF;AACF;AA0BA;EAEE;IAEE,wBAAA;EA1BF;EA6BA;IAEE,2BAAA;EA5BF;EA+BA;IACE,0BAAA;EA7BF;AACF","sourcesContent":["// Create a new file: components/JusticeLoader/JusticeLoader.scss\n.loading-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  min-height: 300px;\n  width: 100%;\n  padding: 40px;\n}\n\n.justice-loader {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  text-align: center;\n  gap: 1rem;\n\n  .gavel {\n    font-size: 48px;\n    margin-bottom: 16px;\n    animation: swing 1.5s ease-in-out infinite;\n    transform-origin: center top;\n\n    .gavel-img {\n      width: 60px;\n      height: 60px;\n    }\n  }\n\n  .loading-text {\n    font-size: 16px;\n    color: #666;\n    font-weight: 500;\n    opacity: 0.8;\n    animation: pulse 2s ease-in-out infinite;\n  }\n}\n\n// Enhanced swing animation\n@keyframes swing {\n\n  0%,\n  100% {\n    transform: rotate(0deg);\n  }\n\n  20% {\n    transform: rotate(15deg);\n  }\n\n  40% {\n    transform: rotate(-10deg);\n  }\n\n  60% {\n    transform: rotate(5deg);\n  }\n\n  80% {\n    transform: rotate(-2deg);\n  }\n}\n\n@keyframes pulse {\n\n  0%,\n  100% {\n    opacity: 0.6;\n  }\n\n  50% {\n    opacity: 1;\n  }\n}\n\n// Alternative hammer-style loader if you prefer\n.hammer-loader {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n\n  .hammer {\n    font-size: 40px;\n    margin-bottom: 16px;\n    animation: hammer 1s ease-in-out infinite;\n    transform-origin: bottom center;\n  }\n\n  .anvil {\n    font-size: 24px;\n    margin-bottom: 16px;\n    animation: anvil-shake 1s ease-in-out infinite;\n  }\n}\n\n@keyframes hammer {\n\n  0%,\n  100% {\n    transform: rotate(0deg);\n  }\n\n  25% {\n    transform: rotate(-45deg);\n  }\n\n  50% {\n    transform: rotate(-90deg);\n  }\n\n  75% {\n    transform: rotate(-45deg);\n  }\n}\n\n@keyframes anvil-shake {\n\n  0%,\n  100% {\n    transform: translateX(0);\n  }\n\n  25%,\n  75% {\n    transform: translateX(-2px);\n  }\n\n  50% {\n    transform: translateX(2px);\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
